import {
  AdjustBillingRequestBodyType,
  AdjustBillingResponseBodyType,
} from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useDialogs } from "@src/hooks/dialog";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys, subscriptionProductKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const adjustBilling = async (
  payload: ApiRequest<AdjustBillingRequestBodyType>
) => {
  const resp = await api.post<
    AdjustBillingResponseBodyType,
    AdjustBillingRequestBodyType
  >(`/v2/organizations/adjust-billing`, payload.body);

  return resp.data;
};

export const useAdjustBilling = (dontOpenPaymentLink?: boolean) => {
  const queryClient = useQueryClient();
  const org = useGetOrg();
  const { openDialog, closeDialog } = useDialogs();

  return useMutation<
    AdjustBillingResponseBodyType,
    Error,
    ApiRequest<AdjustBillingRequestBodyType>
  >({
    mutationKey: ["adjustBilling"],
    mutationFn: async (payload: ApiRequest<AdjustBillingRequestBodyType>) =>
      adjustBilling(payload),
    onMutate: (payload) => {
      if (["create", "upgrade", "downgrade"].includes(payload.body.action)) {
        closeDialog("upgradeToProfitOptimization");
        if (!dontOpenPaymentLink) {
          openDialog("waitForShopify");
        }
      }
    },
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey: organizationsKeys.orgSummary(org.data.org.id),
      });
      await queryClient.invalidateQueries({
        queryKey: subscriptionProductKeys.all,
      });
      closeDialog("waitForShopify");
      if (payload.body.action !== "cancel" && data && !dontOpenPaymentLink) {
        window.open(data);
      }
    },
  });
};
